import React from "react";
import "../styles/PrivacyPolicyStyle.css";

const JZCTerms = () => {
  return (
    <div className="jazz_discount_outer">
      <div className="container">
        <div className="discount_inner">
          <h2>Terms &amp; Conditions and Content Policy</h2>
          <br />

          <br />

          {/* Section 1: Definitions and Acceptance of Terms */}
          <h3>1. Definitions and Acceptance of Terms</h3>

          <h3>1.1 Definitions</h3>
          <p>
            In these Terms and Conditions, unless the context requires
            otherwise, the following capitalized terms shall have the meanings
            set out below:
          </p>
          <ul>
            <li>
              <strong>"Company"</strong> means Celsius, the entity that owns and
              operates the Platform.
            </li>
            <li>
              <strong>"Platform"</strong> means the Jobup website (
              <a href="https://Jobup.mobi/home">https://Jobup.mobi/home</a>),
              mobile application, and all associated digital properties through
              which the Services are delivered.
            </li>
            <li>
              <strong>"Services"</strong> means all content, features,
              functionality, and subscription-based services offered on or
              through the Platform, whether accessed as a guest or as a
              registered user.
            </li>
            <li>
              <strong>"User", "you", or "your"</strong> means any individual who
              accesses, browses, or uses the Platform or the Services, whether
              as a guest or a registered user.
            </li>
            <li>
              <strong>"Billing Provider"</strong> means the third-party mobile
              carrier, payment gateway, or other entity through which
              subscription fees are charged and collected on behalf of the
              Company (e.g., JazzCash or other mobile wallets).
            </li>
            <li>
              <strong>"Content"</strong> means all text, images, graphics,
              videos, audio, software, data compilations, page layout,
              underlying code, and any other materials available on or through
              the Platform.
            </li>
            <li>
              <strong>"User Content"</strong> means any content, including but
              not limited to comments, reviews, ratings, feedback, or other
              materials, posted, submitted, uploaded, or otherwise shared by a
              User on or through the Platform.
            </li>
            <li>
              <strong>"Privacy Policy"</strong> means the Company's privacy
              policy as published on the Platform and updated from time to time,
              which governs the collection, use, storage, and protection of
              personal information.
            </li>
            <li>
              <strong>"Terms" or "Terms and Conditions"</strong> means these
              terms and conditions, together with the Privacy Policy and any
              schedules, annexures, or documents expressly incorporated by
              reference.
            </li>
          </ul>
          <br />

          <h3>1.2 Acceptance</h3>
          <p>
            Welcome to Jobup, an innovative platform designed to foster
            insightful conversations and share knowledge. These Terms and
            Conditions outline the legal framework governing your use of the
            Platform and the Services.
          </p>
          <p>
            Please read these Terms carefully before you start to use the
            Services. By accessing, browsing, or using the Services, you
            acknowledge that you have read, understood, and agree to be bound by
            these Terms and the Privacy Policy. If you do not agree with any
            provision herein, you must not access or use the Platform.
          </p>
          <p>
            Your use of the Platform implies acknowledgment and acceptance of
            these Terms. Continued use of the Platform following the posting of
            any revised Terms constitutes your acceptance of and agreement to
            such changes.
          </p>
          <br />

          {/* Section 2: Eligibility and Age Requirements */}
          <h3>2. Eligibility and Age Requirements</h3>
          <p>
            The Services are intended for users who are at least eighteen (18)
            years of age. By using the Platform, you represent and warrant that
            you are at least 18 years old and have the legal capacity to enter
            into a binding agreement. If you are under the age of 18, you may
            only use the Services under the direct supervision and with the
            express consent of a parent or legal guardian who agrees to be bound
            by these Terms.
          </p>
          <p>
            The Company reserves the right to request proof of age at any time
            and to terminate or suspend any account where the User is found to
            be ineligible. The Company is not responsible for any
            misrepresentation of age by Users.
          </p>
          <br />

          {/* Section 3: User Account and Account Security */}
          <h3>3. User Account and Account Security</h3>
          <p>
            To access certain features of the Platform, Users may be required to
            create an account. You are responsible for:
          </p>
          <ul>
            <li>
              Providing accurate, current, and complete information during
              registration and keeping such information up to date.
            </li>
            <li>
              Maintaining the confidentiality of your account credentials,
              including your username and password.
            </li>
            <li>
              All activities that occur under your account, whether or not
              authorized by you.
            </li>
            <li>
              Informing us promptly of any unauthorized access to or use of your
              account or any other breach of security.
            </li>
          </ul>
          <p>
            Your account is personal to you. You agree not to share, transfer,
            or provide access to your account to any other person. The Company
            does not permit account sharing, and any account found to be shared
            among multiple users may be suspended or terminated without notice.
          </p>
          <p>
            We reserve the right to disable any username, password, or other
            identifier, whether chosen by you or provided by us, at any time in
            our sole discretion for any or no reason, including if, in our
            opinion, you have violated any provision of these Terms.
          </p>
          <br />

          {/* Section 4: Service Subscription and Billing */}
          <h3>4. Service Subscription and Billing</h3>

          <h3>4.1 Subscription Plans</h3>
          <p>
            The Services are provided to the Billing Provider's customers at a
            subscription fee. Subscriptions can be purchased at{" "}
            <a href="https://Jobup.mobi/home">https://Jobup.mobi/home</a> and
            through other advertising links as promoted by the Company.
            Subscribers can opt for the following subscription plan(s) to avail
            access to the Platform:
          </p>
          <br />
          <div className="terms-table-container">
            <table
              className="terms-table"
              border={1}
              cellPadding="8"
              cellSpacing="0"
            >
              <thead>
                <tr>
                  <th colSpan={2}>Weekly (7 days)</th>
                  <th colSpan={2}>Monthly (30 days)</th>
                </tr>
                <tr>
                  <th>Excl. Tax</th>
                  <th>Incl. Tax</th>
                  <th>Excl. Tax</th>
                  <th>Incl. Tax</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Rs. 50</td>
                  <td>Rs. 60</td>
                  <td>Rs. 360</td>
                  <td>Rs. 430</td>
                </tr>
                <tr>
                  <td>Rs. 75</td>
                  <td>Rs. 89</td>
                  <td>Rs. 460</td>
                  <td>Rs. 549</td>
                </tr>
                <tr>
                  <td>Rs. 100</td>
                  <td>Rs. 119</td>
                  <td>Rs. 560</td>
                  <td>Rs. 668</td>
                </tr>
                <tr>
                  <td>Rs. 125</td>
                  <td>Rs. 149</td>
                  <td>Rs. 660</td>
                  <td>Rs. 788</td>
                </tr>
                <tr>
                  <td>Rs. 150</td>
                  <td>Rs. 179</td>
                  <td>—</td>
                  <td>—</td>
                </tr>
              </tbody>
            </table>
          </div>
          <br />

          <h3>4.2 Auto-Renewal</h3>
          <p>
            All subscription plans are set to auto-renew at the end of each
            billing cycle unless you cancel your subscription before the renewal
            date. By subscribing, you expressly authorize the Company and/or the
            applicable Billing Provider to charge the subscription fee
            automatically at the start of each renewal period. It is your sole
            responsibility to manage and cancel your subscription if you no
            longer wish to use the Services.
          </p>
          <p>
            The Company is under no obligation to send reminders or
            notifications prior to the auto-renewal of your subscription.
          </p>
          <br />

          <h3>4.3 Billing and Payment</h3>
          <p>
            Subscription fees are charged through the applicable Billing
            Provider (e.g., mobile carrier billing). The billing date is
            determined by the date of your initial subscription and will recur
            based on the plan selected (weekly or monthly). All charges are
            non-refundable except where expressly stated otherwise or required
            by applicable law.
          </p>
          <br />

          <h3>4.4 Failed Payments and Retries</h3>
          <p>
            In the event of a failed payment, the Company and/or the Billing
            Provider may attempt to re-charge the subscription fee up to three
            (3) times within a period of seventy-two (72) hours. If all retry
            attempts fail, your access to premium content may be suspended until
            a successful payment is processed. You remain liable for any unpaid
            subscription charges that accrued during the period of attempted
            access.
          </p>
          <br />

          <h3>4.5 Free Trials and Promotional Offers</h3>
          <p>
            The Company may from time to time offer free trial periods or
            promotional subscription rates. Unless you cancel before the end of
            the trial or promotional period, your subscription will
            automatically convert to a paid subscription at the then-current
            standard rate for the plan selected. By accepting a free trial or
            promotional offer, you acknowledge and consent to this automatic
            conversion.
          </p>
          <br />

          <h3>4.6 Changes to Pricing</h3>
          <p>
            The Company reserves the right to change subscription fees,
            introduce new pricing tiers, or run special offers from time to
            time, in which it can offer discounted or free subscriptions to the
            Billing Provider's customers. Any changes to pricing will be
            communicated to Users in advance where commercially practicable.
            Continued use of the Services after a price change takes effect
            constitutes acceptance of the revised pricing.
          </p>
          <br />

          {/* Section 5: Communications and Notifications */}
          <h3>5. Communications and Notifications</h3>
          <p>
            During service activation, the subscriber consents to receiving text
            messages, push notifications, and other electronic communications
            regarding new features, updates, service-related alerts, promotional
            offers, and administrative notices from the Company. Text messages
            are sent from the Billing Provider's network and do not incur any
            additional charges beyond standard carrier rates.
          </p>
          <p>
            You may opt out of promotional communications at any time by
            following the unsubscribe instructions provided in such messages.
            However, you may not opt out of service-related or administrative
            communications that are necessary for the operation of your account.
          </p>
          <br />

          {/* Section 6: Content Ownership and Intellectual Property */}
          <h3>6. Content Ownership and Intellectual Property</h3>
          <p>
            All Content available on the Platform, including but not limited to
            text, images, graphics, videos, audio, software, data compilations,
            page layout, underlying code, and any other materials, is the
            intellectual property of the Company or its licensors and is
            protected by applicable intellectual property laws, including
            copyright, trademark, patent, and trade secret laws.
          </p>
          <p>
            The Jobup name, logo, and all related names, logos, product and
            service names, designs, and slogans are trademarks of the Company or
            its affiliates. You must not use such marks without the prior
            written permission of the Company.
          </p>
          <p>
            Nothing in these Terms grants you any right, title, or interest in
            or to any Content or intellectual property of the Company, except
            for a limited, non-exclusive, non-transferable, revocable licence to
            access and use the Services strictly in accordance with these Terms.
          </p>
          <br />

          {/* Section 7: Content Protection and Anti-Piracy */}
          <h3>7. Content Protection and Anti-Piracy</h3>
          <p>
            The Company takes the protection of its Content and the intellectual
            property of its licensors very seriously. You agree that you shall
            not, directly or indirectly:
          </p>
          <ul>
            <li>
              Download, copy, reproduce, record, capture (by screen recording,
              screenshots, or any other means), store, or archive any Content
              available on the Platform.
            </li>
            <li>
              Redistribute, broadcast, re-transmit, publish, or make available
              any Content to any third party by any means, including but not
              limited to social media, file-sharing platforms, or messaging
              services.
            </li>
            <li>
              Circumvent, disable, or otherwise interfere with any digital
              rights management technology, encryption, or other content
              protection mechanisms used by the Company.
            </li>
            <li>
              Remove, alter, or obscure any copyright, trademark, or other
              proprietary notices on any Content.
            </li>
            <li>
              Use any automated tools, bots, scrapers, or other software to
              access, extract, or index Content from the Platform.
            </li>
            <li>
              Create derivative works based on any Content available on the
              Platform.
            </li>
          </ul>
          <p>
            Any unauthorized use of Content constitutes a material breach of
            these Terms and may result in immediate termination of your account,
            legal action, and claims for damages.
          </p>
          <br />

          {/* Section 8: User-Generated Content */}
          <h3>8. User-Generated Content</h3>
          <p>
            The Platform may allow Users to post, submit, upload, or otherwise
            share User Content. By submitting User Content, you:
          </p>
          <ul>
            <li>
              Represent and warrant that you own or have all necessary rights,
              licences, and permissions to submit such User Content and that it
              does not violate any third-party rights or applicable laws.
            </li>
            <li>
              Grant the Company a non-exclusive, worldwide, royalty-free,
              perpetual, irrevocable, sub-licensable, and transferable licence
              to use, reproduce, modify, adapt, publish, translate, create
              derivative works from, distribute, perform, and display such User
              Content in any media and through any channels.
            </li>
            <li>
              Acknowledge that the Company has no obligation to publish,
              display, or retain any User Content and may remove or modify User
              Content at its sole discretion without notice.
            </li>
          </ul>
          <p>
            The Company is not responsible or liable to you or any third party
            for the content or accuracy of any User Content posted by you or any
            other User.
          </p>
          <br />

          {/* Section 9: Prohibited Conduct */}
          <h3>9. Prohibited Conduct</h3>
          <p>
            Users agree not to engage in any conduct that violates these Terms
            or any applicable laws. Prohibited conduct includes but is not
            limited to:
          </p>
          <ul>
            <li>
              Infringement of intellectual property rights of the Company, its
              licensors, or any third party.
            </li>
            <li>
              Interference with or disruption of the proper operation of the
              Platform, its servers, networks, or connected systems.
            </li>
            <li>
              Impersonation of another individual, entity, or falsely
              representing your affiliation with any person or entity.
            </li>
            <li>
              Engagement in any form of illegal, fraudulent, or harmful
              activity.
            </li>
            <li>
              Uploading, transmitting, or distributing any viruses, malware,
              worms, trojan horses, or other harmful or destructive code.
            </li>
            <li>
              Attempting to gain unauthorized access to other user accounts,
              computer systems, or networks connected to the Services.
            </li>
            <li>
              Using the Services for any unauthorized commercial purpose,
              including advertising, solicitation, or spam.
            </li>
            <li>
              Sending, posting, or transmitting any content that is defamatory,
              obscene, threatening, abusive, hateful, or otherwise
              objectionable.
            </li>
            <li>
              Engaging in any activity that could disable, overburden, or impair
              the functioning of the Services or interfere with any other
              party's use and enjoyment of the Services.
            </li>
          </ul>
          <br />

          {/* Section 10: Copyright Infringement and Takedown Procedure */}
          <h3>10. Copyright Infringement and Takedown Procedure</h3>
          <p>
            The Company respects the intellectual property rights of others and
            expects its Users to do the same. If you believe that any content on
            the Platform infringes upon your copyright or other intellectual
            property rights, you may submit a formal written notice to the
            Company containing the following information:
          </p>
          <ul>
            <li>
              A description of the copyrighted work or intellectual property
              that you claim has been infringed.
            </li>
            <li>
              A description of the location on the Platform where the allegedly
              infringing material is located, with sufficient detail to enable
              us to find it.
            </li>
            <li>
              Your full legal name, address, telephone number, and email
              address.
            </li>
            <li>
              A statement that you have a good faith belief that the use of the
              material is not authorized by the copyright owner, its agent, or
              the law.
            </li>
            <li>
              A statement, made under penalty of perjury, that the information
              in your notice is accurate and that you are the copyright owner or
              are authorized to act on the copyright owner's behalf.
            </li>
            <li>Your physical or electronic signature.</li>
          </ul>
          <p>
            Notices should be sent to:{" "}
            <a href="mailto:support@celsius.cc">support@celsius.cc</a>. The
            Company will investigate all valid notices and take appropriate
            action, which may include removal of the allegedly infringing
            content and suspension or termination of the accounts of repeat
            infringers.
          </p>
          <br />

          {/* Section 11: Third-Party Links and Content */}
          <h3>11. Third-Party Links and Content</h3>
          <p>
            The Platform may contain links to third-party websites,
            applications, or resources. These links are provided for your
            convenience only. The Company does not control or endorse the
            content, privacy practices, or availability of those third-party
            sites or resources and accepts no responsibility for them or for any
            loss or damage that may arise from your use of them. If you decide
            to access any third-party websites or services linked to or from the
            Platform, you do so entirely at your own risk and subject to the
            terms and conditions of those websites and services.
          </p>
          <p>
            The inclusion of any link does not imply endorsement, sponsorship,
            or recommendation by the Company of the linked site or any
            association with its operators.
          </p>
          <br />

          {/* Section 12: Service Availability and Modifications */}
          <h3>12. Service Availability and Modifications</h3>
          <p>
            We reserve the right to withdraw, amend, modify, or discontinue any
            aspect of the Services, and any service, feature, or material we
            provide through the Platform, in our sole discretion and without
            prior notice. We will not be liable if, for any reason, all or any
            part of the Services is unavailable at any time or for any period.
          </p>
          <p>
            The Company does not guarantee uninterrupted, continuous, or
            error-free access to the Services. The Services may be subject to
            limitations, delays, interruptions, and other problems inherent in
            the use of the internet and electronic communications. The Company
            shall not be liable for any loss, damage, or inconvenience arising
            from any such interruption, suspension, or discontinuation of the
            Services, whether planned or unplanned.
          </p>
          <p>
            No compensation, credit, or refund shall be payable to any User for
            any period of downtime, interruption, or unavailability of the
            Services.
          </p>
          <br />

          {/* Section 13: Reliance on Information Posted */}
          <h3>13. Reliance on Information Posted</h3>
          <p>
            The information presented on or through the Platform is made
            available solely for general information purposes. We do not warrant
            the accuracy, completeness, or usefulness of this information. Any
            reliance you place on such information is strictly at your own risk.
            We disclaim all liability and responsibility arising from any
            reliance placed on such materials by you or any other visitor to the
            Platform, or by anyone who may be informed of any of its contents.
          </p>
          <p>
            The Platform may include content provided by third parties. All
            statements and opinions expressed in such third-party materials are
            solely the responsibility of the person or entity providing those
            materials and do not necessarily reflect the opinion of the Company.
          </p>
          <br />

          {/* Section 14: Disclaimer of Warranties */}
          <h3>14. Disclaimer of Warranties</h3>
          <p>
            YOUR USE OF THE SERVICES, ITS CONTENT, AND ANY ITEMS OBTAINED
            THROUGH THE SERVICES IS AT YOUR OWN RISK. THE SERVICES, ITS CONTENT,
            AND ANY ITEMS OBTAINED THROUGH THE SERVICES ARE PROVIDED ON AN "AS
            IS" AND "AS AVAILABLE" BASIS, WITHOUT ANY WARRANTIES OF ANY KIND,
            EITHER EXPRESS OR IMPLIED.
          </p>
          <p>
            NEITHER THE COMPANY NOR ANY PERSON ASSOCIATED WITH THE COMPANY MAKES
            ANY WARRANTY OR REPRESENTATION WITH RESPECT TO THE COMPLETENESS,
            SECURITY, RELIABILITY, QUALITY, ACCURACY, OR AVAILABILITY OF THE
            SERVICES. WITHOUT LIMITING THE FOREGOING, NEITHER THE COMPANY NOR
            ANYONE ASSOCIATED WITH THE COMPANY REPRESENTS OR WARRANTS THAT THE
            SERVICES, ITS CONTENT, OR ITEMS OBTAINED THROUGH THE SERVICES WILL
            BE ACCURATE, RELIABLE, ERROR-FREE, OR UNINTERRUPTED, THAT DEFECTS
            WILL BE CORRECTED, THAT THE PLATFORM OR THE SERVERS THAT MAKE IT
            AVAILABLE ARE FREE OF VIRUSES OR OTHER HARMFUL COMPONENTS, OR THAT
            THE SERVICES WILL OTHERWISE MEET YOUR NEEDS OR EXPECTATIONS.
          </p>
          <p>
            TO THE FULLEST EXTENT PROVIDED BY LAW, THE COMPANY HEREBY DISCLAIMS
            ALL WARRANTIES OF ANY KIND, WHETHER EXPRESS OR IMPLIED, STATUTORY,
            OR OTHERWISE, INCLUDING BUT NOT LIMITED TO ANY WARRANTIES OF
            MERCHANTABILITY, NON-INFRINGEMENT, AND FITNESS FOR A PARTICULAR
            PURPOSE.
          </p>
          <p>
            THE FOREGOING DOES NOT AFFECT ANY WARRANTIES THAT CANNOT BE EXCLUDED
            OR LIMITED UNDER APPLICABLE LAW.
          </p>
          <br />

          {/* Section 15: Limitation of Liability */}
          <h3>15. Limitation of Liability</h3>
          <p>
            TO THE FULLEST EXTENT PROVIDED BY LAW, IN NO EVENT WILL THE COMPANY,
            ITS AFFILIATES, OR THEIR RESPECTIVE LICENSORS, SERVICE PROVIDERS,
            EMPLOYEES, AGENTS, OFFICERS, PARTNERS, OR DIRECTORS BE LIABLE FOR
            DAMAGES OF ANY KIND, UNDER ANY LEGAL THEORY, ARISING OUT OF OR IN
            CONNECTION WITH YOUR USE, OR INABILITY TO USE, THE SERVICES, ANY
            WEBSITES LINKED TO IT, ANY CONTENT ON THE PLATFORM OR OTHER
            WEBSITES, INCLUDING ANY DIRECT, INDIRECT, SPECIAL, INCIDENTAL,
            CONSEQUENTIAL, OR PUNITIVE DAMAGES, INCLUDING BUT NOT LIMITED TO
            PERSONAL INJURY, PAIN AND SUFFERING, EMOTIONAL DISTRESS, LOSS OF
            REVENUE, LOSS OF PROFITS, LOSS OF BUSINESS OR ANTICIPATED SAVINGS,
            LOSS OF USE, LOSS OF GOODWILL, LOSS OF DATA, AND WHETHER CAUSED BY
            TORT (INCLUDING NEGLIGENCE), BREACH OF CONTRACT, OR OTHERWISE, EVEN
            IF FORESEEABLE.
          </p>
          <br />

          {/* Section 16: Indemnification */}
          <h3>16. Indemnification</h3>
          <p>
            You agree to defend, indemnify, and hold harmless the Company, its
            affiliates, licensors, and service providers, and their respective
            officers, directors, employees, contractors, agents, licensors,
            suppliers, successors, and assigns from and against any claims,
            liabilities, damages, judgments, awards, losses, costs, expenses, or
            fees (including reasonable attorneys' fees) arising out of or
            relating to:
          </p>
          <ul>
            <li>Your violation of these Terms.</li>
            <li>
              Your use of the Services, including but not limited to any User
              Content you submit.
            </li>
            <li>
              Any use of the Platform's content, services, and products other
              than as expressly authorized in these Terms.
            </li>
            <li>
              Any infringement or misappropriation of any intellectual property
              or other right of any third party.
            </li>
            <li>
              Any claim that your User Content caused damage to a third party.
            </li>
            <li>
              Any third-party claim or demand arising out of your use of the
              Platform.
            </li>
          </ul>
          <br />

          {/* Section 17: Termination and Suspension */}
          <h3>17. Termination and Suspension</h3>
          <p>
            The Company reserves the right to terminate, suspend, or restrict
            your account and access to the Services, in whole or in part, at its
            sole discretion, without prior notice or liability, for any reason
            deemed appropriate, including but not limited to:
          </p>
          <ul>
            <li>Violation of these Terms.</li>
            <li>Suspected fraudulent, abusive, or illegal activity.</li>
            <li>Non-payment of subscription fees.</li>
            <li>Requests by law enforcement or other government agencies.</li>
            <li>Extended periods of inactivity.</li>
          </ul>
          <p>
            Upon termination, your right to use the Services will immediately
            cease. All provisions of these Terms which by their nature should
            survive termination shall survive, including but not limited to
            ownership provisions, warranty disclaimers, indemnification, and
            limitations of liability.
          </p>
          <p>
            You may cancel your subscription at any time by unsubscribing
            through the method provided on the Platform or by contacting us.
            Cancellation will take effect at the end of the current billing
            cycle, and no refund will be provided for any unused portion of the
            subscription period.
          </p>
          <br />

          {/* Section 18: Privacy Policy */}
          <h3>18. Privacy Policy</h3>
          <p>
            In conjunction with these Terms, the Privacy Policy outlines the
            manner in which we collect, use, store, and protect your personal
            information. Your use of the Platform is also governed by the terms
            set forth in the Privacy Policy, which is incorporated herein by
            reference.
          </p>
          <p>
            All User information shall remain confidential for all purposes
            unless required to be disclosed to government departments or
            agencies under applicable law, or otherwise agreed to be disclosed
            with the consent of the User.
          </p>
          <br />

          {/* Section 19: Data Protection and Security */}
          <h3>19. Data Protection and Security</h3>
          <p>
            The Company implements commercially reasonable technical and
            organizational measures to protect User data against unauthorized
            access, alteration, disclosure, or destruction. However, no method
            of transmission over the internet or method of electronic storage is
            completely secure, and the Company cannot guarantee absolute
            security.
          </p>
          <p>
            You are responsible for implementing sufficient procedures and
            safeguards to satisfy your particular requirements for data
            protection and for maintaining a means external to the Services for
            the reconstruction of any lost data.
          </p>
          <br />

          {/* Section 20: Changes to Terms and Conditions */}
          <h3>20. Changes to Terms and Conditions</h3>
          <p>
            The Company reserves the right to modify, amend, or update these
            Terms at any time in its sole discretion. All changes are effective
            immediately when we post them and apply to all access to and use of
            the Services thereafter. Users will be notified of significant
            changes where commercially practicable. Your continued use of the
            Services following the posting of revised Terms means that you
            accept and agree to the changes. You are expected to check this page
            periodically, so you are aware of any changes, as they are binding
            on you.
          </p>
          <br />

          {/* Section 21: Force Majeure */}
          <h3>21. Force Majeure</h3>
          <p>
            The Company shall not be liable for any failure or delay in the
            performance of its obligations due to causes beyond its reasonable
            control, including but not limited to acts of God, war, terrorism,
            insurrection, civil disorder, national or local emergency, acts or
            omissions of government or any competent authority, industrial
            disputes of any kind, fire, lightning, explosion, flood, weather of
            exceptional severity, epidemic, pandemic, natural disasters, power
            failures, internet service provider failures, technical failures,
            cyberattacks, and interruption of services for maintenance of
            systems.
          </p>
          <br />

          {/* Section 22: Governing Law and Dispute Resolution */}
          <h3>22. Governing Law and Dispute Resolution</h3>

          <h3>22.1 Governing Law</h3>
          <p>
            These Terms shall be governed by and construed in accordance with
            the laws of the Islamic Republic of Pakistan, without regard to its
            conflict of law provisions.
          </p>

          <h3>22.2 Amicable Resolution</h3>
          <p>
            If any difference or dispute arises between the parties in
            connection with these Terms, the parties shall first endeavour to
            resolve the dispute amicably through good faith negotiations within
            thirty (30) days of written notice of the dispute.
          </p>

          <h3>22.3 Arbitration</h3>
          <p>
            If the dispute cannot be resolved amicably within the period
            specified in Section 22.2, either party may refer the matter to
            binding arbitration in accordance with the Arbitration Act, 1940, as
            amended, or any successor legislation. The seat of arbitration shall
            be Islamabad, Pakistan, the language of arbitration shall be
            English, and the arbitral award shall be final and binding on both
            parties.
          </p>

          <h3>22.4 Jurisdiction</h3>
          <p>
            Notwithstanding Section 22.3, either party retains the right to seek
            interim or injunctive relief from the competent courts located in
            Islamabad, Pakistan, to prevent irreparable harm pending the outcome
            of arbitration. For the enforcement of any arbitral award, and for
            any matters not subject to arbitration under applicable law, the
            competent courts located in Islamabad, Pakistan, shall have
            exclusive jurisdiction.
          </p>
          <br />

          {/* Section 23: Severability */}
          <h3>23. Severability</h3>
          <p>
            If any provision of these Terms is held by a court or other tribunal
            of competent jurisdiction to be invalid, illegal, or unenforceable
            for any reason, such provision shall be eliminated or limited to the
            minimum extent necessary such that the remaining provisions of these
            Terms will continue in full force and effect.
          </p>
          <br />

          {/* Section 24: Waiver */}
          <h3>24. Waiver</h3>
          <p>
            The failure of the Company to enforce any right or provision of
            these Terms will not be considered a waiver of those rights. No
            waiver by the Company of any term or condition shall be deemed a
            further or continuing waiver of such term or condition or a waiver
            of any other term or condition. Any waiver of any provision of these
            Terms must be in writing and signed by an authorized representative
            of the Company.
          </p>
          <br />

          {/* Section 25: Entire Agreement */}
          <h3>25. Entire Agreement</h3>
          <p>
            These Terms, together with the Privacy Policy and any additional
            agreements or policies referenced herein, constitute the entire
            agreement between you and the Company with respect to the Services,
            superseding any prior agreements, communications, or understandings,
            whether written or oral, regarding the Services.
          </p>
          <br />

          {/* Section 26: Contact Information */}
          <h3>26. Contact Information</h3>
          <p>
            For any questions, concerns, or complaints regarding these Terms,
            you may contact us at:
          </p>
          <p>
            <strong>Jobup (operated by Celsius)</strong>
            <br />
            Website:{" "}
            <a href="https://Jobup.mobi/home">https://Jobup.mobi/home</a>
            <br />
            Email: <a href="mailto:support@celsius.cc">support@celsius.cc</a>
          </p>
          <br />

          {/* Schedule A: Promotional Terms and Conditions */}
          <h3>SCHEDULE A</h3>
          <h3>Promotional Terms and Conditions</h3>
          <p>
            The following promotional terms and conditions form part of the
            Terms and are subject to all provisions of the main Terms and
            Conditions above. All references to "the Company" in this Schedule
            refer to Celsius, as defined in Section 1.1 of these Terms.
          </p>
          <br />

          <h3>A.1 Vouchers Giveaway Promotion</h3>
          <p>
            <em>(Updated: 30-10-2025)</em>
          </p>
          <p>
            The "Vouchers Giveaway" promotion is managed by the Company for
            Jobup subscribers who join via the official JazzCash campaign. The
            following terms apply:
          </p>
          <ul>
            <li>
              Eligible Pakistani users with an active paid subscription are
              automatically entered into a monthly draw.
            </li>
            <li>
              Ten (10) winners are selected randomly each month and receive free
              food vouchers.
            </li>
            <li>
              Winners are notified via SMS and/or call within seven (7) days of
              the draw.
            </li>
            <li>
              Unclaimed vouchers may be forfeited at the sole discretion of the
              Company.
            </li>
            <li>
              Each voucher has a fixed monetary value, is non-transferable,
              non-refundable, and subject to restaurant/vendor terms and
              conditions.
            </li>
            <li>
              The Company may modify or terminate the promotion at any time
              without prior notice.
            </li>
            <li>
              The Company bears no responsibility for third-party vendor
              quality, service, or redemption issues.
            </li>
            <li>
              By accepting a voucher, winners consent to the use of their name
              and mobile number for promotional purposes.
            </li>
            <li>
              Participation releases the Company and its affiliates from any
              liability related to the promotion.
            </li>
            <li>
              This promotion is governed by the laws of Pakistan and subject to
              the dispute resolution provisions in Section 22 of these Terms.
            </li>
          </ul>
          <p>
            For queries, visit{" "}
            <a href="https://Jobup.mobi/home">https://Jobup.mobi/home</a>.
          </p>
          <br />

          <h3>A.2 Subscribe and Win Contest</h3>
          <p>
            <strong>Reward:</strong> Smart Watch (monthly): one (1) winner will
            be selected through a lucky draw each month.
          </p>
          <p>
            <strong>Winner Announcement:</strong>
          </p>
          <ul>
            <li>
              The winner will be selected randomly from all eligible entries.
            </li>
            <li>
              The Company's decision regarding the selection of the winner is
              final and binding.
            </li>
            <li>
              The winner will be notified via call within seventy-two (72) hours
              of the draw date.
            </li>
            <li>
              The winner's name will also be announced on the Company's official
              Instagram and Facebook accounts.
            </li>
          </ul>
          <p>
            <strong>Eligibility and Conditions:</strong>
          </p>
          <ul>
            <li>
              To be eligible, the User must have been successfully charged at
              least once during the relevant month.
            </li>
            <li>
              The winner will be chosen from the list of active subscribers
              during the relevant month.
            </li>
            <li>
              The Company reserves the right and discretion to set, change, or
              withdraw the price, rate, or reward of any offer or the Subscribe
              and Win campaign at any time.
            </li>
            <li>
              By participating, the winner grants the Company the right to use
              their name, photograph, and related information for promotional
              and marketing purposes.
            </li>
            <li>
              The winner must be a citizen of Pakistan and must have a JazzCash
              account associated with the winning mobile number.
            </li>
            <li>
              Prizes are non-transferable and cannot be exchanged for cash or
              other alternatives. The Company reserves the right to substitute a
              prize with another of equal or higher value if necessary.
            </li>
            <li>
              Employees, affiliates, and immediate family members of the Company
              are not eligible to participate.
            </li>
            <li>
              The Company's decision is final and no correspondence or
              complaints will be entertained.
            </li>
            <li>
              The winner may provide a photograph for marketing and media
              purposes, and the Company shall have the right to use such images
              without seeking prior approval.
            </li>
            <li>
              The Company reserves the right to amend or change these
              promotional terms at its discretion.
            </li>
            <li>
              If, for any reason, the competition cannot run for its entire
              duration due to a computer virus, tampering, unauthorized
              intervention, fraud, technical failures, or any other cause beyond
              the reasonable control of the Company, the Company reserves the
              right in its sole discretion to (a) disqualify any entrant, or (b)
              modify, suspend, terminate, or cancel the promotion, as
              appropriate.
            </li>
            <li>
              No User may claim any reward or benefit beyond what is announced
              or decided by the Company.
            </li>
          </ul>
          <p>
            <strong>Limitation of Liability:</strong>
          </p>
          <ul>
            <li>
              The Company is not responsible for any loss, damage, or injury
              resulting from participation in the contest or the use of prizes.
            </li>
            <li>
              Participants agree to release the Company from any liability
              associated with the contest and waive any right to pursue legal
              claims for damages.
            </li>
          </ul>
          <p>
            <strong>Disqualification:</strong>
          </p>
          <ul>
            <li>
              If the Company's call centre contacts a winner and the winner does
              not respond within twenty-four (24) hours, the winner will be
              disqualified.
            </li>
            <li>
              The Company reserves the right to disqualify participants who
              violate these terms or engage in fraudulent activities.
            </li>
            <li>
              The Company reserves the right to modify, suspend, or terminate
              the contest at any time without prior notice.
            </li>
          </ul>
          <br />
        </div>
      </div>
    </div>
  );
};

export default JZCTerms;
